module.exports = __webpack_public_path__ + "img/twentuno.7fd6eb3c.jpg";